import Page from 'commons/page'
import Block from 'components/block'
import { BaseContainer, BaseContent } from 'components/layout'
import { PropertyListTitle } from 'components/typography'
import { useEffect, useState } from 'react'
import UserApi from '../../apis/user'
import SettingToggle from '../../components/setting-toggle'
import { NotificationSetting as NotificationSettingRecord } from '../../schema/user'

// 通知設定種別
const NotificationTypes = [
  {
    key: 'notification.new.chat',
    name: 'チャットの新着メッセージ',
  },
]

const NotificationSetting = () => {
  const [userSettings, setUserSettings] = useState<
    NotificationSettingRecord[] | null
  >()
  const [settings, setsSettings] = useState<
    { key: string; name: string; isEnable: boolean }[]
  >([])

  useEffect(() => {
    ;(async () => {
      const result = (await UserApi.fetchNotificationSettings()).data
      setUserSettings(result)
    })()
  }, [])

  useEffect(() => {
    if (!userSettings) {
      return
    }
    const notificationSettingList = NotificationTypes.map((item) => {
      const userSetting = userSettings.find(
        (matchItem) => matchItem.key === item.key
      )
      if (userSetting) {
        return { ...item, isEnable: userSetting.isEnable }
      } else {
        return { ...item, isEnable: true }
      }
    })

    setsSettings(notificationSettingList)
  }, [userSettings])

  const onChange = async (key: string, value: boolean) => {
    const updatedSettings = settings.map((setting) => {
      if (setting.key === key) {
        return {
          ...setting,
          isEnable: value,
        }
      }
      return setting
    })
    setsSettings(updatedSettings)

    // API送信
    await UserApi.saveNotificationSetting(key, value)
  }

  return (
    <Page title="通知設定" type="user">
      <BaseContainer col>
        <BaseContent width="400px" maxWidth="100%">
          <PropertyListTitle>通知設定</PropertyListTitle>
          <Block>
            {settings.map((item) => (
              <SettingToggle
                key={item.key}
                targetKey={item.key}
                labelName={item.name}
                value={item.isEnable}
                onChange={onChange}
              />
            ))}
          </Block>
        </BaseContent>
      </BaseContainer>
    </Page>
  )
}

export default NotificationSetting
